var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"BarChart"},[_c('div',{staticClass:"text-large text-center"},[_vm._t("title")],2),_c('div',[_c('svg',{ref:"chart"})]),_c('div',{ref:"tooltip",staticClass:"Tooltip"})])}
var staticRenderFns = []

export { render, staticRenderFns }